// extracted by mini-css-extract-plugin
module.exports = {"btn-ok":"Controls--btn-ok--2ar1L","btnOk":"Controls--btn-ok--2ar1L","btn-cancel":"Controls--btn-cancel--2TWL8","btnCancel":"Controls--btn-cancel--2TWL8"};